export default "__VITE_ASSET__38WBGILs__"